import React, { useEffect, useState, } from 'react';

import GetSharedFileList from '../components/GetSharedFileList';

import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../../shared/hooks/http-hook';

const GetSharedFiles = () => {
    const [loadedFiles, setLoadedFiles] = useState();
    const { isLoading, error, sendRequest, clearError } = useHttpClient();

    useEffect(() => {
        const fetchFiles = async () => {
            try {
                const sharedToken = localStorage.getItem('sharedToken');

                if (!sharedToken) {
                    throw new Error('No shared token found');
                }

                const responseData = await sendRequest(
                    process.env.REACT_APP_BACKEND_URL + `/files/shared`,
                    'GET',
                    null,
                    {
                        Authorization: 'Bearer ' + sharedToken
                    }
                       
                );
                //setLoadedFiles(responseData.files);
                setLoadedFiles(responseData.sharedFiles);
                
            }   catch (err) { }
        };
        fetchFiles();
    },    [sendRequest]);

    const deleteFileHandler = fileId => {
        setLoadedFiles(prevFiles =>
            prevFiles.filter(file => file._id !== fileId)
        );
    };

    if (isLoading) {
        return <LoadingSpinner asOverlay />;
    }

    return (
        <React.Fragment>
            <ErrorModal error={error} onClear={clearError} />
            {/*
            {isLoading && (
                <div className="center">
                    <LoadingSpinner />
                </div>
            )}
            */}
            {!isLoading && loadedFiles && <GetSharedFileList items={loadedFiles} onDeleteFile={deleteFileHandler} />}
        </React.Fragment>
    );

};

export default GetSharedFiles;
